<template>
  <div>
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <ChometzSalesView />
        <GlobalFooter>
          <p class="global-footer__text">
            The Chometz Sale dates are provided by Hebcal.com with a CC BY 4.0
            International License.
          </p>
        </GlobalFooter>
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import ChometzSalesView from "./ChometzSalesView.vue";
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import { useMainStore } from "@/stores/useMainStore";
import { UserRoles as Roles } from "@/Domain/UserRoles";
import AccessHandler from "@/shared/access/AccessHandler.vue";

const main = useMainStore();

const roleGroups = [
  {
    roles: [
      Roles.ROLE_IN_HOUSE_MIS_MANAGER,
      Roles.ROLE_MIS,
      Roles.ROLE_PESACH_ADMINISTRATION,
      //...Roles.ROLES_ALL_RC,
    ],
    validateRestrictionsAsync: async () => {
      return (
        main.companySummary?.JewishOwned || main.companySummary?.HasJewishPlants
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.global-footer__text {
  font-size: 12px;
  margin-left: 12px;
  color: #999;
}
</style>
